import React, { FC, ReactNode, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import ActivityFrame from "../../../components/activity-frame/activity-frame";
import Breadcrumb from "../../../components/breadcrumb/breadcrumb";
import Tabs, { getTabsListFromLabels } from "../../../components/tabs/tabs";
import { toast } from "react-toastify";
import HolidayTab from "../../../containers/holidays-tab";
import { useLocale } from "../../../contexts/localeContext";
import Restricted from "../../../contexts/PermissionProvider/RestrictedWrapper";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { Button } from "../../../components/button/Button";
import plusIcon from "../../../images/Plus.svg";
import { Category } from "../../../models/Category";
import { getHolidays } from "../../../services/holidaysService";
import { showError } from "../../../services/utilities/ServiceError";
import { Filter } from "../../../models/Filter";
import { getListOfSiteIdsFromFilter, shouldUpdateCategory } from "../../../utilities/tabUtils";
import { useTabCount } from "../../../hooks/useCategoryTab";

const Holiday: FC = () => {
    const [selected, setSelected] = useState(0);
    const [busy, setBusy] = useState(false);
    const history = useHistory();
    const [categories, setCategories] = useState<Category[]>([]);
    const [tabContent, setTabContent] = useState<ReactNode[]>([]);
    const { translate } = useLocale();

    const { updateTabCount } = useTabCount({
        tableName: "Holiday",
        categories,
        setCategories,
    });

    useEffect(() => {
        buildCategoriesData();
    }, []);

    const buildCategoriesData = async () => {
        try {
            setBusy(true);
            setCategories([
                {
                    displayName: translate.byKey(TranslationKeys.holidays),
                    heading: translate.byKey(TranslationKeys.holidays),
                    value: "",
                    id: 0,
                    count: 0,
                },
            ]);
            setBusy(false);
        } catch (error) {
            showError(error, toast.warn);
        }

    }

    const onFilterChange = (filters: Filter[]) => {
        const siteIds = getListOfSiteIdsFromFilter(filters);
        updateTabCount(siteIds);
    };

    useEffect(() => {
        if (categories.length > 0) {
            const newTabContent = [
                <HolidayTab 
                    setBusy={setBusy} 
                    categories={categories} 
                    setCategories={setCategories}
                    onFilterChange={onFilterChange}
                />
            ];
            setTabContent(newTabContent);
        }
    }, [categories]);

    return (
        <>
            <ActivityFrame
                busy={busy}
                className="flex flex-grow overflow-y-hidden">
                <div id="container-tabs" className="pt-4 pl-4 pb-4 flex flex-col flex-grow ">
                    <Breadcrumb
                        path={[
                            {
                                value: "/access-control/configuration",
                                displayName: translate.byKey(TranslationKeys.configuration),
                                disableClick: true
                            },
                            {
                                value: "/access-control/configuration/holidays",
                                displayName: translate.byKey(TranslationKeys.holidays),
                            },
                        ]}
                        onClick={(item) => history.push(item.value)} />
                    <Tabs
                        className="overflow-y-hidden"
                        tabs={getTabsListFromLabels(categories)}
                        onSelect={(i) => setSelected(i)}
                        selected={selected}
                        onAdd={() => { }}
                        add={false}
                        tabStyle={{}}>
                        {tabContent[selected]}
                        <div className="flex flex-col flex-grow overflow-y-hidden mb-viewport">
                            <div className="flex flex-row justify-end button-cluster">
                                <Restricted to={`add.holidays.element`}>
                                    <Link
                                        to={{
                                            pathname:
                                                "/access-control/configuration/holiday/",
                                        }}>
                                        <Button variant="submit" shape="rounded" id='addHolidayButton'>
                                            <img
                                                src={plusIcon}
                                                className="px-2 w-8 py-1"
                                                alt="" />
                                            <span className="mr-2">{translate.byKey(TranslationKeys.add)}</span>
                                        </Button>
                                    </Link>
                                </Restricted>
                            </div>
                        </div>
                    </Tabs>
                </div>
            </ActivityFrame>
        </>
    );
};

export default Holiday;
